import React, { useEffect, useRef, useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import { SearchInput } from "../search/SearchInput";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Paper } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import Chip from '@mui/material/Chip';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { IconButton } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';


const StyledIconButton = withStyles({
    root: {
      padding: 0,
      marginRight: '5px',
    },
  })(IconButton);


export function SentenceQATable(props) {
    const { arr_question_data, arr_awnswer_data, setOpenSentenceQuestionElementSelected, setOpenSentenceAnswerElementSelected } = props;
    const [ arrDataGrid, setArrDataGrid ] = useState([]) 
    // const [ isLoadingDataGrid, setIsLoadingDataGrid ] = useState(true);

    const [filterTags, setFilterTags] = useState([
        { tagName: "01. TODAS", isActive: true }, 
        { tagName: "02. CELADOR PUERTA", isActive: true }, 
        { tagName: "03. ADMISIÓN Identificación paciente", isActive: true }, 
        { tagName: "04. ADMISIÓN Causa asistencia Urgencias", isActive: true }, 
        { tagName: "05. ADMISIÓN Identificación seguros", isActive: true }, 
        { tagName: "06. ADMISIÓN Perfilado", isActive: true }, 
        { tagName: "07. ADMISIÓN Espera triaje", isActive: true }, 
        { tagName: "08. TRIAJE Preguntas", isActive: true }, 
        { tagName: "09. TRIAJE Espera médico", isActive: true }, 
        { tagName: "10. ADMISIÓN Alta Urgencias", isActive: true }, 
    ]);
    
    const [ question_selected, setQuestion_selected ] = useState('');
    const [columns, setColumns] = useState([
        { field: "text", headerName: "RESPUESTAS", headerAlign: 'center', align: 'center', sortable: false, flex: 0.4 },
    ]);

    const handleAccordionClick = (id) => {

        console.log("🚀 ~ file: SentencesTable.js:22 ~ handleClickAccordion ~ id:", id)
        console.log('handleClickAccordion - CLICK ACCORDION SUMMARY')
        if (question_selected === '') {
            setQuestion_selected(id)
            console.log("🚀 ~ file: SentencesTable.js:41 ~ handleAccordionClick ~ id:", id)
            const arr_answer_idx = arr_question_data[id].arr_answers
            console.log("🚀 ~ file: SentencesTable.js:43 ~ handleAccordionClick ~ arr_answer_idx:", arr_answer_idx)
            const arrData = arr_answer_idx.map((elemento, indice) => {
                return { 'id': elemento, 'text': arr_awnswer_data[elemento].text};
            });
            console.log("🚀 ~ file: SentencesTable.js:47 ~ handleAccordionClick ~ arrData:", arrData)

            setArrDataGrid(arrData) 
        }else{
            setQuestion_selected('')
            setArrDataGrid([])
        }

    }

    function handleTagClick(tagString) {
        console.log("🚀 ~ handleTagClick ~ tagString:", tagString)
        const activeTags = [];
        const newFilterTags = filterTags.map((tag) => {
          if (tag.tagName === tagString) {
            if (!tag.isActive) { activeTags.push(tag.tagName); }
            return { ...tag, isActive: !tag.isActive };
          } else {
            if (tag.isActive) { activeTags.push(tag.tagName); }
            return tag;
          }
        });
        setFilterTags(newFilterTags);
        
        // const tr = rows.filter(term => term["arr_categories"].some(tag => activeTags.includes(tag)));    
        // setTaggedRows(tr);
        // mixFilters(searchedRows, filteredRows, tr);
      }




    return (
        <>
        <Paper className="sig_Teams_ClassroomRoot" style={{marginTop: '20px', gap: '0px'}}>

            <Grid item>          
                <div className="sig_ST_Tags_Menu">
                    <div className="sig_ST_Tags_Header">
                        <strong> ZONAS </strong>
                    </div>
                    <div className="sig_ST_Tags_Container">
                    {filterTags.map(tag => (
                        <Chip 
                        className={`${tag.isActive ? 'sig_ST_Tag_ON' : 'sig_ST_Tag_OFF'} sig_ST_Tag`} 
                        label={tag.tagName} 
                        onClick={() => handleTagClick(tag.tagName)} 
                        />
                    ))}
                    </div>
                </div>
            </Grid>



            {Object.entries(arr_question_data).map(([key, item]) => {
                const { zone, text, substitle, url_vid, dir_vid, arr_answers } = item;
                return(
                    <>
                        <Accordion  className="sig_Teams_Classroom"  key={key} expanded={question_selected === key}>
                            <AccordionSummary 
                                className="sig_Teams_Classroom_Summary"
                                expandIcon={<ExpandMoreIcon style={{fontSize: '50px', color: '#5ea0d4'}} />}
                                aria-controls="panel1a-content" 
                                id={"summary_"+key} 
                                onClick={() => handleAccordionClick(key)}
                                >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <IconButton 
                                        onClick={(event) => {
                                            event.stopPropagation();
                                        }} 
                                    > 
                                        <PlayCircleOutlineIcon onClick={()=> setOpenSentenceQuestionElementSelected(key)} style={{ color: '#0e72c1' }} /> 
                                    </IconButton>

                                    <div style={{ flex: 4, marginLeft: 10 }}>
                                    { substitle }
                                    </div>
                                    
                                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', marginRight: 10 }}>
                                        {zone.map((z, index) => (
                                            <Chip 
                                                key={index}
                                                className={`sig_ST_Tag_ON sig_ST_Tag`} 
                                                label={z} 
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleTagClick(z);
                                                }} 
                                            />
                                        ))}
                                    </div>
                                </div>
                            </AccordionSummary>
                            { 
                                question_selected === key &&
                                <AccordionDetails>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{backgroundColor: '#1880d2', color: 'white', textAlign: 'center', padding: '10px', borderRadius: '10px'}}>
                                            RESPUESTAS
                                        </div>
                                        {arrDataGrid.map((item, index) => (
                                            <div 
                                                key={index} 
                                                style={{ display: 'flex', alignItems: 'center', textAlign: 'center', padding: '10px', borderBottom: '1px solid #ccc'}}
                                                onClick={() => setOpenSentenceAnswerElementSelected(item.id)}
                                            >
                                                <StyledIconButton 
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setOpenSentenceAnswerElementSelected(item.id)
                                                    // Aquí puedes manejar el clic en el botón
                                                }} 
                                                > 
                                                    <PlayCircleOutlineIcon style={{ color: '#0e72c1' }} /> 
                                                    </StyledIconButton>
                                                    <div style={{ flex: 1 }}>
                                                    {item.text}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </AccordionDetails>
                            }
                            
                        </Accordion>
                    </>
                )

            })}

            </Paper>
        </>
    );

}